import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {ReferenceArea} from "../models/reference-area";
import { map } from 'rxjs/operators';
import {ResponseText} from "@/app/shared/models/shared.model";

@Injectable({
  providedIn: 'root'
})
export class ReferenceAreaDataService {

  constructor(private http: HttpClient) { }

  getReferenceArea = (projectId: number, id: number) :  Promise<ReferenceArea> => {
    return this.http.get<ReferenceArea>(`${environment.api.baseUrl}/${environment.api.endpoints.referenceArea.referenceAreas}/${id}?projectId=${projectId}`).toPromise();
  }

  getReferenceAreas = (projectId: number) :  Observable<ReferenceArea[]> => {
    return this.http.get<ReferenceArea[]>(`${environment.api.baseUrl}/${environment.api.endpoints.referenceArea.referenceAreas}?projectId=${projectId}`).pipe(
      map(referenceAreas => referenceAreas.map(this._processReferenceArea)));
  }

  saveReferenceAreas = (projectId: number, referenceAreas: ReferenceArea[]) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.referenceArea.referenceAreas}?projectId=${projectId}`, referenceAreas.map(referenceArea => {
      return   {
        ...referenceArea,
        area: referenceArea.area && referenceArea.area.positions && referenceArea.area.positions.reduce((acc, pos) => {
            return acc ? acc + " " + pos.latitude + "," + pos.longitude : pos.latitude + "," + pos.longitude
        }, "")
      }
    })).toPromise();
  }

  deleteReferenceArea = (projectId: number, id: number, type: string) => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    .set('type', type);
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.referenceArea.referenceAreas}/${id}`, {params}).toPromise()
  }

  private _processReferenceArea = (referenceArea: ReferenceArea) => {
    return {
      ...referenceArea,
      latLongList: referenceArea.area && referenceArea.area.positions ? referenceArea.area.positions.reduce((acc, position) => {
        return acc ? acc + " " + position.latitude + "," +position.longitude :  position.latitude + "," +position.longitude
      }, '') : ''
    }
  }

  importReferenceAreas = (projectId: number, formData: FormData) :  Observable<ResponseText> => {
    return this.http.post<ResponseText>(`${environment.api.baseUrl}/${environment.api.endpoints.referenceArea.referenceAreasCSV}?projectId=${projectId}`, formData);
  }

}
